const isError = state => state.errorId;
const getLanguage = state => state.language;
const getLanguages = state => state.languages;
const getAppMode = state => state.appMode;
const isDemo = state => state.demo;
const isSideNavOpen = state => state.sideNavOpen;

export default {
  isError,
  getLanguage,
  getLanguages,
  getAppMode,
  isDemo,
  isSideNavOpen,
};
